import { useTheme } from "@emotion/react";
import { BarTimeChartSynced } from "./bar_time_chart";
import { applyAutoScale } from "./chart_options";

export function ProductionChart({ metering, multiDay = false }) {
  const theme = useTheme();

  const utctime = metering.map((el) => new Date(1000 * el.utctime));

  const non_controlled = metering.map((el) => Math.max(0, el.total_production - el.curtailable_production));
  const curtailed = metering.map((el) => Math.max(0, el.curtailment_production));
  const non_curtailed = metering.map((el) => Math.max(0, el.curtailable_production - el.curtailment_production));

  const setpoint_line = metering.map(
    (el) => Math.max(0, el.total_production - el.curtailable_production) + el.curtailable_production_setpoint,
  );

  const total_prod = metering.map((el) => el.total_production);

  const data = {
    labels: utctime,
    datasets: [
      {
        label: "Non-controlled Production",
        data: non_controlled,
        backgroundColor: theme.palette.production.dark,
      },
      {
        label: "Non-curtailed Production",
        data: non_curtailed,
        backgroundColor: theme.palette.production.main,
      },
      {
        label: "Curtailed Production",
        data: curtailed,
        backgroundColor: theme.palette.curtailment.main,
      },
      {
        fill: false,
        label: "Production Setpoint",
        data: setpoint_line,
        borderWidth: 2,
        borderColor: "grey",
        backgroundColor: "transparent",
        cubicInterpolationMode: "monotone",
        pointStyle: false,
        type: "line",
        order: -1,
        stack: "setpoint",
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    interaction: {
      mode: "index",
      intersect: false,
    },
    scales: {
      x: {
        type: "time",
        time: {
          tooltipFormat: "dd/MM/yyyy HH:mm",
          displayFormats: {
            hour: multiDay ? "dd/MM HH:mm" : "HH:mm",
          },
          unit: "hour",
          stepSize: 1,
        },
        stacked: true,
        grid: {
          offset: false,
        },
      },
      y: {
        stacked: true,
        min: 0,
      },
    },
    plugins: {
      legend: {
        position: "bottom",
        display: true,
      },
    },
  };

  const { unit, divisor } = applyAutoScale(options, [non_controlled, non_curtailed, curtailed, setpoint_line], "W");
  options.plugins.tooltip = {
    callbacks: {
      afterBody: function (context) {
        const index = context[0].dataIndex;
        const total = total_prod[index];
        return "Total Production: " + +(total / divisor).toFixed(2) + " " + unit;
      },
    },
  };

  return <BarTimeChartSynced data={data} options={options} />;
}
